// This file is automatically generated. Do not edit manually.

import { CatalogPartRevisionLine } from "src/api/generated/erp/db/types/tables/catalogPartRevisionLine";
import { CatalogPartRevisionLineView } from "src/api/generated/erp/db/types/tables/catalogPartRevisionLineView";
import { BomLineGroup } from "src/api/generated/erp/db/types/tables/bomLineGroup";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CatalogPartRevisionBomDataGridApi {
	export async function getData(args: {
		catalogPartRevisionId: number;
		searchQuery?: string;
	}): Promise<CatalogPartRevisionBomDataGridApi_DataGridData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPartRevisionBom/getData",
			method: "POST",
			data: {
				catalogPartRevisionId: args.catalogPartRevisionId,
				searchQuery: args.searchQuery,
			},
		});
		return response as CatalogPartRevisionBomDataGridApi_DataGridData;
	}

	export async function save(args: {
		revisionLines: Array<CatalogPartRevisionLine>;
	}): Promise<Array<CatalogPartRevisionLineView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPartRevisionBom/save",
			method: "POST",
			data: {
				revisionLines: args.revisionLines,
			},
		});
		return response as Array<CatalogPartRevisionLineView>;
	}

	export async function delete_(args: { revisionLines: Array<CatalogPartRevisionLine> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPartRevisionBom/delete",
			method: "POST",
			data: {
				revisionLines: args.revisionLines,
			},
		});
		return response as void;
	}
}

export interface CatalogPartRevisionBomDataGridApi_DataGridData {
	bomLineGroupOptions: Array<BomLineGroup>;
	revisionLines: Array<CatalogPartRevisionLineView>;
}
